import React, { ReactElement } from 'react';
import { PropagateLoader, PulseLoader } from 'react-spinners';

import '../styles/components/Loader.less';

interface Props {
    size: number;
    loading?: boolean;
    overComponent?: boolean;
    skipOverlay?: boolean;
    moonLoader?: boolean;
}

/* If used over single component the parent div needs to get position relative */
const Loader = ({ size, loading, overComponent, skipOverlay, moonLoader }: Props): ReactElement => {
    return (
        <>
            {loading && (
                <div
                    data-testid="loader"
                    className={`${!skipOverlay ? 'overlay' : ''} ${!overComponent ? 'fixed-height' : ''}`}
                >
                    <div className="spinner">
                        {moonLoader ? (
                            <PropagateLoader size={size} color={'#AAA'} loading={loading} />
                        ) : (
                            <PulseLoader size={size} color={'#AAA'} loading={loading} />
                        )}
                    </div>
                </div>
            )}
        </>
    );
};

export default Loader;
